import { Component,OnInit } from '@angular/core';

declare var google: any;

@Component({
  selector: 'app-hubs',
  templateUrl: './hubs.component.html',
  styleUrls: ['./hubs.component.css']
})
export class HubsComponent implements OnInit{
  ngOnInit() {
    google.charts.load('current', { packages: ['corechart'] });
    google.charts.setOnLoadCallback(this.drawChart);
  }

  drawChart() {
    const data1 = new google.visualization.DataTable();
    data1.addColumn('string', 'Versions');
    data1.addColumn('number', 'Number of Devices');
    data1.addRows([
      ['v1.0.487', 197],
      ['v1.0.566', 853],
      ['v1.0.598', 643],
      ['v1.1.100', 265],
      ['v1.1.007', 99],
      ['v1.1.112', 48],
      ['v1.1.135', 9],
      ['v1.1.277', 111],
      ['v1.1.350', 98],
      ['v1.1.670', 32],
      ['v1.1.888', 23],
      ['v1.1.500', 65],
      ['v1.1.993', 725],
      ['v1.2.0', 53],
      ['v1.2.1', 17]
    ]);

    const options = {
      title: 'Kidde Version App Insight',
      width: 400,
      height: 400,
      is3D: true
    };

    const chart = new google.visualization.PieChart(document.getElementById('hubs'));
    chart.draw(data1, options);
  }
}
